const initialState = null;

const ReservationArranger = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationArranger":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationArranger;
